import * as ModelAPI from "api/ModelAPI";

const UPDATE_FIELD = "modelGroup/UPDATE_FIELD";
const UPDATE_OPTIONS = "modelGroup/UPDATE_OPTIONS";

const initialState = {};

function modelOptionsReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: { ...action.data }
      };
    case UPDATE_OPTIONS:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
}

/* Selectors */
export function getBase(state) {
  return state.modelOptions;
}

export function getModelOptions(state) {
  let options = getBase(state);

  for (const option of Object.keys(options)) {
    options[option].isIncluded = true;
  }

  return options;
}

/* Actions */
export function updateModelOptions(modelOptions) {
  let retModelOptions = {};

  modelOptions &&
    Object.keys(modelOptions).forEach((m) => (retModelOptions[modelOptions[m].name] = { ...modelOptions[m] }));

  return {
    type: UPDATE_OPTIONS,
    data: retModelOptions
  };
}

export function fetchModelOptions() {
  return (dispatch, getState) => {
    return ModelAPI.getModelOptions().then((response) => dispatch(updateModelOptions(response)));
  };
}

export default modelOptionsReducer;
